import { Component, Input } from '@angular/core';
import { Address } from '@lsq-frontend/remote-services/enterprise/common';

import { Icons } from '@lsq-frontend/common-ui';

@Component({
    selector: 'search-customer-card',
    template: `
        <div class="search-customer-card">
            <div>
                <h3 class="bold overflow-text">{{ name }}</h3>
                <p><lsq-address [address]="address" [singleLine]="true"></lsq-address></p>
            </div>
            <div class="spacer-item"></div>
            <ng-content></ng-content>
        </div>
    `,
    styleUrls: ['./search-customer-card.component.scss']
})
export class SearchCustomerCardComponent {
    @Input() public name: string;
    @Input() public address: Address;
    public icons = Icons;
}
